"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scene2dCategorySorted = void 0;
const rc_js_util_1 = require("rc-js-util");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * sorts entities by z order.
 */
class Scene2dCategorySorted {
    constructor(update2dGroup) {
        this.update2dGroup = update2dGroup;
    }
    getSortedCategories(updateGroup) {
        return updateGroup.categories
            .toArray()
            .slice()
            .sort((a, b) => a.zIndex - b.zIndex);
    }
    getEntitiesByComponents(category) {
        const entitiesByCollection = rc_js_util_1._Array.collect(category.getEntities(), new Map(), (entitiesByComponent, entity) => {
            const component = this.update2dGroup.graphicsComponents.getComponent(entity);
            this.collectComponents(entitiesByComponent, component, entity);
        });
        return Array.from(entitiesByCollection.entries());
    }
    collectComponents(entitiesByComponent, component, entity) {
        switch (component.type) {
            case core_1.EGraphicsComponentType.Composite:
                {
                    if (component.groupUpdatesByEntity) {
                        rc_js_util_1._Map.push(entitiesByComponent, component, entity);
                    }
                    else {
                        const components = component.subComponents.getSubComponents();
                        for (let i = 0, iEnd = components.length; i < iEnd; ++i) {
                            this.collectComponents(entitiesByComponent, components[i], entity);
                        }
                    }
                    break;
                }
            case core_1.EGraphicsComponentType.Entity:
                {
                    rc_js_util_1._Map.push(entitiesByComponent, component, entity);
                    break;
                }
            default:
                rc_js_util_1._Production.assertValueIsNever(component);
        }
    }
    update() {
        const zRange = this.getZRange(this.update2dGroup);
        const squashFactor = -1 / rc_js_util_1._Math.max(zRange, 1);
        let prev = 0;
        const categories = this.getSortedCategories(this.update2dGroup);
        for (let i = 0, iEnd = categories.length; i < iEnd; i++) {
            const category = categories[i];
            const entities = category.getEntities();
            for (let j = 0, jEnd = entities.length; j < jEnd; j++) {
                const settings = entities[j].graphicsSettings;
                DEBUG_MODE && rc_js_util_1._Debug.assert(settings.zIndexRel >= 0, "expected ZIndexRel to be set");
                settings.zIndexAbs = (prev + settings.zIndexRel) * squashFactor;
            }
            prev += category.entityZIndexRange + 1;
        }
    }
    getZRange(updateGroup) {
        let range = 0;
        const categories = updateGroup.categories.toArray();
        for (let i = 0, iEnd = categories.length; i < iEnd; i++) {
            const category = categories[i];
            if (category.getEntities().length !== 0) {
                range += category.entityZIndexRange + 1;
            }
        }
        return range;
    }
}
exports.Scene2dCategorySorted = Scene2dCategorySorted;
//# sourceMappingURL=scene2d-category-sorted.js.map